module.exports = __webpack_public_path__ + "assets/img/1af00edbd87531ca5a5a351debe72531.svg";